import { Individual } from '@aslanpay/portal-common-lib';
import { Button, Flex, Text } from '@chakra-ui/react';
import useFetchPointsTransactions from 'app/hooks/useFetchPointsTransactions';
import { getGiftingPath } from 'app/utils/routes';
import { useNavigate } from 'react-router-dom';

import RewardHistoryTable from '../../Gifting/RewardHistoryTable';
import CenterSpinner from '../../UI/CenterSpinner';
import EmptyState from '../../UI/EmptyState';

interface EmployeeProfileGiftingDetailsProps {
  employee: Individual;
}

function EmployeeProfileGiftingDetails({ employee }: EmployeeProfileGiftingDetailsProps) {
  const navigate = useNavigate();

  const handleSeeRewardingHistory = () => {
    navigate(getGiftingPath());
  };

  // Fetch Reward History Transactions
  const { data: rewardHistoryData, isLoading: isRewardHistoryLoading } = useFetchPointsTransactions(
    {
      individualIds: [employee.id],
      directions: ['CREDIT'],
      reasons: ['EMPLOYEE_GIFT'],
      sortBy: 'createdAt',
      sort: 'DESC',
      size: 3,
      page: 0,
    }
  );

  if (isRewardHistoryLoading) {
    return (
      <Flex
        mx={{ base: 0, md: '60px', xl: '100px' }}
        borderRadius="10px"
        border="1px solid"
        borderColor="brand.lightGray1"
      >
        <CenterSpinner />
      </Flex>
    );
  }

  return (
    <Flex
      mx={{ base: 0, md: '60px', xl: '100px' }}
      borderRadius="10px"
      border="1px solid"
      borderColor="brand.lightGray1"
      flexDir="column"
      flexWrap="wrap"
    >
      <Flex justifyContent="space-between" align="center" p="20px">
        <Text color="brand.purple" textStyle="h5Bold">
          Gifting
        </Text>
        <Button size="sm" variant="link" onClick={handleSeeRewardingHistory}>
          See rewarding history
        </Button>
      </Flex>
      <Flex
        w="full"
        p="20px"
        gap="20px"
        justifyContent="start"
        borderTop="1px solid"
        borderColor="brand.lightGray1"
        flexDir="column"
      >
        <Text color="brand.purple" textStyle="h6SemiBold">
          History
        </Text>
        {rewardHistoryData?.list.length ? (
          <RewardHistoryTable transactions={rewardHistoryData.list} />
        ) : (
          <EmptyState text="No rewarding history available." />
        )}
      </Flex>
    </Flex>
  );
}

export default EmployeeProfileGiftingDetails;
